export default {"src":"/_next/static/media/O.4130fbd6.svg","height":18,"width":18};